import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatPhoneDisplay } from "@shared/utils/phone"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Display a phone number consistently as `555-123-4567` (issue #401).
 * Delegates to the shared canonical formatter; empty stays empty.
 */
export function formatPhoneNumber(value: string): string {
  return formatPhoneDisplay(value);
}

export function unformatPhoneNumber(value: string): string {
  return value.replace(/[^\d]/g, '');
}

export function formatDateToYMD(date: Date | null | undefined): string | null {
  if (!date) return null;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
